import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {vignettesView_template} from '../components/templates/vignettesView_template';
import {header} from './header';
import { vn_app_zone_notification } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification';

declare var ko: any;
declare var page: any;

export class vignettes_view extends vnModule_knockoutJS{

    protected vignetteView: vignettesView_template
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return 'vignettes_view';
    }

    buildContent(): Array<Element>{
        this.vignetteView = new vignettesView_template('vignettes_view', this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Vignette');

        return [this.vignetteView.build()];
    }

    public fillPage(): void{

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.vignetteView.setBrand(idBrand);
        }
        this.getVignette();
    }

    protected cancel() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page(`/brand/${idBrand}/categorization/vignettes`);
    }

    public copyToClipboardAlert(): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Copied To Clipboard');
        this.getVnAppZone().showNotificationToModule();
    }

    protected getVignette(){

        this.loadingIn(this.vignetteView.builtTemplate);

        let idVignette = this.getVnAppZone().getApp().params.id;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let brandReq_url: string = '';
        if (idBrand) {
            brandReq_url = `/brand/${idBrand}`;
        }
        let usrReq_url: string = `/api${brandReq_url}/tags/vignettes/get/${idVignette}`;

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.vignetteView.getViewModelForRequest();

        usrReq_params.push(['data', ko.toJSON(vm)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetVignetteRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetVignetteRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response).data;
                obj.setVignette(responseParsed.vignette);
            });

            obj.loadingOut(obj.vignetteView.builtTemplate);
        }
    }

    public setVignette(data): void{
        this.vignetteView.setId(data.id);
        this.vignetteView.setName(data.name);
        this.vignetteView.setCss(data.css);
        this.vignetteView.setHtml(data.html);
        this.vignetteView.setJs(data.js);
        this.vignetteView.setBrandOwner(data.brandOwner);
        this.vignetteView.setStylesheets(data.stylesheets || []);
    }


    protected edit(id){

        let url: string = `/categorization/vignettes/edit/${id}`;
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let urlBrand = '';
        if (idBrand) {
            urlBrand = `/brand/${idBrand}`;
        }

        page(`${urlBrand}${url}`);

    }
}



// WEBPACK FOOTER //
// ./js/modules/vignettes_view.ts